import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle2 q-pa-md bg-grey-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "row no-wrap q-pa-md" }
const _hoisted_4 = { class: "column justify-center items-center" }
const _hoisted_5 = { class: "q-mt-md" }
const _hoisted_6 = { class: "column items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_change_password_btn = _resolveComponent("change-password-btn")!
  const _component_logout_btn = _resolveComponent("logout-btn")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    icon: "fa fa-user",
    rounded: "",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.appUser.account.name), 1),
        _hoisted_2
      ]),
      _createVNode(_component_q_separator),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_icon, {
            name: "fa fa-user-circle",
            size: "md"
          }),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.displayName), 1)
        ]),
        _createVNode(_component_q_separator, {
          vertical: "",
          inset: "",
          class: "q-mx-lg"
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_change_password_btn, {
            "user-id": _ctx.appUser.id,
            icon: "fa fa-lock",
            flat: ""
          }, null, 8, ["user-id"]),
          _createVNode(_component_logout_btn, {
            icon: "fa fa-sign-out-alt",
            flat: "",
            class: "q-mt-sm"
          })
        ])
      ])
    ]),
    _: 1
  }))
}